import React from 'react'
import EditableText from '@/components/editable/EditableText'

const ROLES = [
  {
    t: 'Mécènes & fondations',
    d: "Soutenir la construction d'un écosystème suisse durable, ancré localement et tourné vers les nouvelles générations.",
  },
  {
    t: 'Institutions & collectivités',
    d: "Co-construire des programmes pour les jeunes, l'inclusion et la transmission des métiers modernes.",
  },
  {
    t: 'Entreprises & marques',
    d: "Accompagner nos formations, accueillir nos contenus, participer à un projet à fort impact culturel.",
  },
  {
    t: 'Intervenants & experts',
    d: "Rejoindre le laboratoire créatif : artistes, thérapeutes, formateurs, entrepreneurs, makers.",
  },
]

const STATS = [
  { v: '04', l: 'Pôles intégrés' },
  { v: '03', l: 'Sites pilotes' },
  { v: '∞', l: 'Possibilités' },
  { v: '01', l: 'Vision commune' },
]

const Partenaires: React.FC = () => {
  return (
    <section id="partenaires" className="relative bg-[#14253B] py-32 lg:py-44">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 mb-20">
          <div className="lg:col-span-4 reveal">
            <div className="text-[10px] tracking-luxe text-[#C8A24A] mb-4">
              <EditableText as="span" contentKey="partenaires.section.kicker" section="Partenaires" label="Numéro de section">06 — PARTENAIRES</EditableText>
            </div>
            <div className="divider-gold w-24 mb-6" />
            <EditableText
              as="div"
              contentKey="partenaires.eyebrow"
              section="Partenaires"
              label="Partenaires — sous-titre"
              className="text-[12px] tracking-mid uppercase text-[#C9BFA8]"
            >
              Construire ensemble
            </EditableText>
          </div>
          <div className="lg:col-span-8 reveal">
            <h3 className="font-serif-display text-[36px] sm:text-[48px] lg:text-[60px] leading-[1.05] text-[#E8DCC4] text-balance">
              <EditableText contentKey="partenaires.title" section="Partenaires" label="Titre principal" multiline as="span">
                Un projet qui se construit avec ceux qui partagent une ambition réelle.
              </EditableText>
            </h3>
            <p className="mt-8 max-w-3xl text-[16px] leading-[1.75] text-[#C9BFA8]">
              <EditableText contentKey="partenaires.body" section="Partenaires" label="Paragraphe" multiline as="span">
                Le Centre se construit avec des acteurs qui souhaitent participer à des projets utiles, innovants et capables d'avoir un impact humain réel.
              </EditableText>
            </p>
          </div>
        </div>

        <div className="grid lg:grid-cols-2 gap-px bg-[rgba(232,220,196,0.10)] hairline mb-24">
          {ROLES.map((r, i) => (
            <div
              key={r.t}
              className="bg-[#14253B] p-10 lg:p-14 reveal group hover:bg-[#161e22] transition-colors duration-500"
              style={{ transitionDelay: `${i * 70}ms` }}
            >
              <div className="flex items-center gap-4 mb-6">
                <div className="w-2 h-2 rounded-full bg-[#C9E26A]" />
                <div className="text-[11px] tracking-mid uppercase text-[#C8A24A]">{`0${i + 1}`}</div>
              </div>
              <EditableText
                as="h4"
                contentKey={`partenaires.role.${i}.titre`}
                section="Partenaires"
                label={`Rôle ${i + 1} — titre`}
                className="font-serif-display text-[28px] lg:text-[36px] leading-[1.1] text-[#E8DCC4] mb-4"
              >
                {r.t}
              </EditableText>
              <EditableText
                as="p"
                multiline
                contentKey={`partenaires.role.${i}.description`}
                section="Partenaires"
                label={`Rôle ${i + 1} — description`}
                className="text-[15px] leading-[1.75] text-[#C9BFA8] max-w-xl"
              >
                {r.d}
              </EditableText>
              <div className="mt-8 w-10 h-px bg-[#C8A24A]/40 group-hover:w-20 group-hover:bg-[#C9E26A] transition-all duration-500" />
            </div>
          ))}
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-[rgba(232,220,196,0.10)] hairline reveal">
          {STATS.map((s, si) => (
            <div key={s.l} className="bg-[#14253B] p-10 text-center">
              <div className="font-serif-display text-[56px] lg:text-[80px] leading-none text-[#C9E26A]">
                <EditableText contentKey={`partenaires.stat.${si}.value`} section="Partenaires" label={`Statistique ${si + 1} — valeur`} as="span">{s.v}</EditableText>
              </div>
              <div className="mt-3 text-[10px] tracking-luxe uppercase text-[#C9BFA8]">
                <EditableText contentKey={`partenaires.stat.${si}.label`} section="Partenaires" label={`Statistique ${si + 1} — libellé`} as="span">{s.l}</EditableText>
              </div>
            </div>
          ))}
        </div>

        {/* Closing line */}
        <div className="mt-20 lg:mt-24 text-center reveal">
          <div className="divider-gold w-24 mx-auto mb-8" />
          <p className="font-serif-display text-[24px] lg:text-[32px] italic text-[#E8DCC4] max-w-3xl mx-auto leading-[1.4]">
            <EditableText contentKey="partenaires.closing" section="Partenaires" label="Phrase de clôture" multiline as="span">
              Construire des ponts entre innovation, transmission, création et terrain.
            </EditableText>
          </p>
        </div>
      </div>
    </section>
  )
}

export default Partenaires
